/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// カート決済の確認チェック（カートページのみ・jQueryが読み込まれている場合のみ実行）
if (typeof $ !== 'undefined') {
  $(document).ready(function() {
    $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function() {
      if ($('#agree1').is(':checked') && $('#agree2').is(':checked') && $('#agree3').is(':checked') && $('#agree4').is(':checked')) {
        $(this).submit();
      } else {
        alert("確認事項にすべてチェックを入れてください。");
        return false;
      }
    });
  });
}

// 問い合わせフォームにカート内商品を自動追記
(function() {
  var textarea = document.getElementById('contact-form-message');
  if (!textarea) return;

  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (!cart.items || cart.items.length === 0) return;

      var cartText = '\n\n【カート内商品（自動取得）】\n';
      cart.items.forEach(function(item) {
        cartText += '・' + item.product_title;
        if (item.variant_title && item.variant_title !== 'Default Title') {
          cartText += '（' + item.variant_title + '）';
        }
        cartText += ' × ' + item.quantity + '\n';
      });

      textarea.value += cartText;
      textarea.classList.add('is-filled');
    });
})();
// コレクション名の先頭記号を非表示
(function() {
  var symbolPattern = /^[●◆■★◇□○▲▼◎◈]+\s*/;
  function removeSymbols() {
    document.querySelectorAll('.collection-item__title').forEach(function(el) {
      el.childNodes.forEach(function(node) {
        if (node.nodeType === 3 && symbolPattern.test(node.textContent)) {
          node.textContent = node.textContent.replace(symbolPattern, '');
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', removeSymbols);
  } else {
    removeSymbols();
  }
})();